import { configureStore } from "@reduxjs/toolkit";
import uiReducer from "./uiSlice";
import sellerReducer from "./sellerSlice";
import orderReducer from "./ordersSlice";
import subscriptionReducer from "./subscriptionSlice";
import cartReducer from "./cartSlice";
import productsReducer from "../redux/productsSlice";
import authReducer from "../redux/authSlice";
import productFilterReducer from "../redux/authSlice";


export const store = configureStore({
  reducer: {
    ui: uiReducer,
    seller : sellerReducer,
    orders:orderReducer,
    subscription : subscriptionReducer,
    cart: cartReducer,
   products: productsReducer,
   auth: authReducer,
   productFilter: productFilterReducer


  },
});
